import { render, staticRenderFns } from "./OdpCourseDatesSchoolsMenu.vue?vue&type=template&id=053bf948"
import script from "./OdpCourseDatesSchoolsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./OdpCourseDatesSchoolsMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports